/*
 * @Description: 还款申请
 * @Author: 杨志航
 * @Date: 2026-06-25 09:20:35
 */

import React, { useState, useEffect } from 'react'
import {
  Descriptions,
  Spin,
  message,
  Button,
  Input,
  Form,
  Table,
  InputNumber,
} from 'antd'
import api from '@/api'
import { parseSearch, judgeCryptoParamsUrl, allTrim, filterParams } from '@/utils'
import { Link } from 'react-router-dom'

const DItem = Descriptions.Item
const FormItem = Form.Item

const Payback = (props) => {
  const { location, history } = props
  const { getFieldDecorator, getFieldsValue, setFieldsValue } = props.form
  const search = parseSearch(location.search)
  const [loading, setLoading] = useState(true)
  const [settlement, setSettlement] = useState({})
  const [orders, setOrders] = useState([])
  const [fundBalance, setFundBalance] = useState('')
  const [creditMarketPrice, setCreditMarketPrice] = useState('')
  const [creditPredictPrice, setCreditPredictPrice] = useState('')

  useEffect(() => {
    if (judgeCryptoParamsUrl(search)) {
      getDetail()
    } else {
      message.error('没有本页访问权限')
      setTimeout(() => {
        history.goBack()
      }, 1000)
    }
  }, [])

  //获取详情
  const getDetail = () => {
    setLoading(true)
    api.getSettlementOrderRepaymentData({
      id: search.id
    }).then(data => {
      if (search.msgId) {
        api.setMessageReaded({ ids: [search.msgId] })
      }
      setFundBalance(data.fundBalance.toFixed(2))
      setCreditMarketPrice(data.creditMarketPrice)
      setCreditPredictPrice(data.creditPredictPrice)
      setSettlement(data.settlement)
      setOrders(data.orders)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 1 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const relationsCol = [
    {
      title: '订单编号',
      dataIndex: 'orderNumber',
    },
    {
      title: '类型',
      dataIndex: 'orderType',
      render: text => {
        return text === 0 ? '直销' : '代理商'
      }
    },
    {
      title: '订单类型',
      dataIndex: 'orderCategory',
      render: text => {
        return text === 0 ? '提单' : '退单'
      }
    },
    {
      title: '厂商ID',
      dataIndex: 'vendorId',
    },
    {
      title: '项目',
      dataIndex: 'project',
    },
    {
      title: '产品',
      dataIndex: 'product',
    },
    {
      title: '业务类型',
      dataIndex: 'businessType',
    },
    {
      title: '市场价',
      dataIndex: 'marketPrice',
    },
    {
      title: '预计收款',
      dataIndex: 'predictPrice',
    },
    {
      title: '收款类型',
      dataIndex: 'paymentType',
    },
    {
      title: '订单负责人',
      dataIndex: 'manager',
    },
  ]

  const handlePass = () => {
    let params = {
      id: settlement.id,
    }
    setFieldsValue(allTrim(getFieldsValue()))
    const vals = filterParams(getFieldsValue())
    if (vals.payRemark) {
      params.payRemark = vals.payRemark
    }
    setLoading(true)
    api.repaymentSettlementOrder(params).then(() => {
      message.success('还款成功')
      history.goBack()
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  //刷新余额
	const refreshAcount = () => {
		api.getOrderRefreshBalance({
			type: settlement.clientType,
      relationId: settlement.clientId,
      companyId: settlement.companyId
		}).then(data => {
			data.available && setFundBalance(data.available.balance)
		})
	}

  return (
    <Spin spinning={loading}>
      <div className="pro-detail">
        <Descriptions 
          layout="vertical"
          column={5}
          style={{ marginBottom: '10px' }}
        >
          <DItem label="结算单编号">{settlement.settlementNo}</DItem>
          <DItem label="结算单月份">{settlement.settlementMonth}</DItem>
          <DItem label="对方主体">{settlement.clientName}</DItem>
          <DItem label="我方主体">{settlement.companyName}</DItem>
          <DItem label="结算方式">{settlement.settlementMethodName}</DItem>
          <DItem label="系统充值">{settlement.systemRecharge}</DItem>
          <DItem label="本月消耗">{settlement.monthConsume}</DItem>
          <DItem label="应付金额">{settlement.payable}</DItem>
          <DItem label="业务审批人">{settlement.businessApproverNameList?.map(item => item.name).join(',')}</DItem>
          <DItem label="内控审批人">{settlement.internalApproverName}</DItem>
        </Descriptions>
        <div className="line-box"></div>
        <Descriptions
          title="结算单还款"
          className="pro-detail-smailtitle"
          layout="vertical"
          column={5}
        >
          <DItem label="可用余额">
            <div>
              ￥ {fundBalance}
              <Link 
                target="_blank" 
                to={`/fund/moneyClaim/detail?clientId=${settlement.clientId}&clientType=${settlement.clientType}`}
                style={{ marginLeft: 5 }}
              >认款</Link>
              <a onClick={refreshAcount} style={{ marginLeft: 5 }}>刷新余额</a>
            </div>
          </DItem>
          <DItem label="还款市场价">
            <InputNumber
              precision={2}
              disabled
              value={creditMarketPrice}
              style={{ width: '100%' }}
            />
          </DItem>
          <DItem label="预计收款">
            <InputNumber
              precision={2}
              disabled
              value={creditPredictPrice}
              style={{ width: '100%' }}
            />
          </DItem>
        </Descriptions>
        <Form {...formItemLayout} style={{ marginTop: 20 }}>
          <FormItem label="还款备注">
            {getFieldDecorator('payRemark')(
              <Input.TextArea placeholder="请输入备注信息" rows={4} maxLength={500}/>
            )}
          </FormItem>
        </Form>
        <div className="line-box"></div>
        <Descriptions 
          title="结算单关联订单"
          className="pro-detail-smailtitle"
        >
        </Descriptions>
        <Table 
          rowKey={(record, i) => i}
          columns={relationsCol} 
          dataSource={orders} 
          pagination={false}
          bordered
          style={{ marginBottom: '20px' }}
          size="middle"
        />
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '40px' }}>
          <Button onClick={() => history.goBack()}>取消</Button>
          <Button type="primary" onClick={handlePass} style={{ marginLeft: '15px' }}>提交</Button>
        </div>
      </div>
    </Spin>
  )
}

export default Form.create()(Payback)
